import { z } from '../index.ts'

export const GetStatusSchema = z.object({
  alias: z.string(),
  order: z.number().optional(),
  title: z.string(),
})

export const GetStatusReasonSchema = z.object({
  content: z.string(),
  id: z.number(),
  slug: z.enum([
    'cancelled_by_shipper',
    'cancelled_by_admin',
    'cancelled_by_haulier',
    'cancelled_test_load',
    'expired_shipper_fault',
    'expired_admin_fault',
    'transport_failed',
    'all_good',
    'issues_with_customer',
    'issues_with_carrier',
    'our_fault',
    'other',
  ]),
})
